<mat-form [formGroup]="formArray">
    <div *ngFor="let formGroup of formArray.controls; let i = index">
        <mat-form [formGroup]="formGroup">
            <div class="first-row">
                <mat-form-field>
                    <input
                        matInput
                        [matDatepicker]="picker"
                        formControlName="need_date"
                        placeholder="MM/DD/YYYY"
                        (dateChange)="onFormChange(i, 'need_date')"
                    />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- <input matInput type="date" placeholder="MM/DD/YYYY"/> -->
                </mat-form-field>
                <mat-form-field>
                    <mat-select
                        placeholder="Type"
                        formControlName="delivery_type"
                        (selectionChange)="onFormChange(i, 'delivery_type')"
                    >
                        <mat-option value="Set"> Set </mat-option>
                        <mat-option value="Flow"> Flow </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        placeholder="Unit Qty"
                        formControlName="unit_qty"
                        (input)="onFormChange(i, 'unit_qty')"
                    />
                </mat-form-field>
                <button mat-button color="secondary" (click)="onRemoveDelivery(i)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </mat-form>
    </div>
</mat-form>
<button mat-button color="secondary" (click)="onAddDelivery()">+ Add Delivery</button>
